import { addLocaleData, IntlProvider } from 'react-intl';
import arLocaleData from 'react-intl/locale-data/ar';
import esLocaleData from 'react-intl/locale-data/es';
import translations from 'utils/i18n/locales';
import { LOCALE } from 'utils/constants';

addLocaleData(arLocaleData);
addLocaleData(esLocaleData);
const intlProvider = new IntlProvider({
  locale: LOCALE,
  messages: translations[LOCALE]
});
const { intl } = intlProvider.getChildContext(); 
export default intl;